module.exports = __webpack_public_path__ + "static/media/birthdate.d60a8132.gif";